export interface IPageNoPresentable {
  getPageCount(): number;
  getCurrentPageNo(): number;
}

export function instanceOfIPageNoPresentable(instance: any): instance is IPageNoPresentable {
  return instance
  && (instance.getPageCount !== undefined)
  && (instance.getCurrentPageNo !== undefined);
}
